import { each, isNumber } from '@antv/util';
import { getMaxLabelWidth } from '../../util/label';
import { getMatrixByAngle } from '../../util/matrix';
import Theme from '../../util/theme';
// ç»ä¸è®¾ç½®ææ¬çè§åº¦
function setLabelsAngle(labels, angle) {
    each(labels, function (label) {
        var x = label.attr('x');
        var y = label.attr('y');
        var matrix = getMatrixByAngle({ x: x, y: y }, angle);
        label.attr('matrix', matrix);
    });
}
// æè½¬ææ¬
function labelRotate(isVertical, labelsGroup, limitLength, getAngle) {
    var labels = labelsGroup.getChildren();
    if (!labels.length) {
        return false;
    }
    if (!isVertical && labels.length < 2) {
        // æ°´å¹³æ¶è³å°æä¸¤ä¸ªæ¶ææè½¬
        return false;
    }
    var maxWidth = getMaxLabelWidth(labels);
    var isOverlap = false;
    if (isVertical) {
        // limitLength ä¸º 0 æè null æ¶ä¸çæ
        isOverlap = !!limitLength && maxWidth > limitLength;
    }
    else {
        // å limitLength æ å³
        var tickWidth = Math.abs(labels[1].attr('x') - labels[0].attr('x'));
        isOverlap = maxWidth > tickWidth;
    }
    if (isOverlap) {
        var angle = getAngle(limitLength, maxWidth);
        setLabelsAngle(labels, angle);
    }
    return isOverlap;
}
export function getDefault() {
    return fixedAngle;
}
/**
 * åºå®è§åº¦æè½¬ææ¬
 * @param  {boolean} isVertical  æ¯å¦åç´æ¹å
 * @param  {IGroup}  labelsGroup ææ¬ç group
 * @param  {number}  limitLength éå®é¿åº¦
 * @param  {number}  customRotate èªå®ä¹æè½¬è§åº¦
 * @return {boolean}             æ¯å¦åçäºæè½¬
 */
export function fixedAngle(isVertical, labelsGroup, limitLength, customRotate) {
    return labelRotate(isVertical, labelsGroup, limitLength, function () {
        if (isNumber(customRotate)) {
            return customRotate;
        }
        return isVertical ? Theme.verticalAxisRotate : Theme.horizontalAxisRotate;
    });
}
/**
 * éåºå®è§åº¦æè½¬ææ¬
 * @param  {boolean} isVertical  æ¯å¦åç´æ¹å
 * @param  {IGroup}  labelsGroup ææ¬ç group
 * @param  {number}  limitLength éå®é¿åº¦
 * @return {boolean}             æ¯å¦åçäºæè½¬
 */
export function unfixedAngle(isVertical, labelsGroup, limitLength) {
    return labelRotate(isVertical, labelsGroup, limitLength, function (length, maxWidth) {
        if (!length) {
            // å¦ææ²¡æè®¾ç½® limitLengthï¼åä½¿ç¨åºå®çè§åº¦æè½¬
            return isVertical ? Theme.verticalAxisRotate : Theme.horizontalAxisRotate;
        }
        if (isVertical) {
            // åç´æ¶ä¸éè¦å¤å® limitLength > maxWidth ï¼å ä¸ºæ­¤æ¶ä¸ä¼ overlap
            return -Math.acos(length / maxWidth);
        }
        else {
            var angle = 0;
            if (length > maxWidth) {
                // éè¦å¤å®ï¼asin çåæ° -1ï¼ 1
                angle = Math.PI / 4;
            }
            else {
                angle = Math.asin(length / maxWidth);
                if (angle > Math.PI / 4) {
                    // å¤§äº Math.PI / 4 æ¶æ²¡æä¹
                    angle = Math.PI / 4;
                }
            }
            return angle;
        }
    });
}
//# sourceMappingURL=auto-rotate.js.map